import { render } from "./trumpet.vue?vue&type=template&id=0c765f2a&scoped=true"
import script from "./trumpet.vue?vue&type=script&lang=js"
export * from "./trumpet.vue?vue&type=script&lang=js"

import "./trumpet.vue?vue&type=style&index=0&id=0c765f2a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c765f2a"]])

export default __exports__